(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("scrollSnap", [], factory);
	else if(typeof exports === 'object')
		exports["scrollSnap"] = factory();
	else
		root["scrollSnap"] = factory();
})(typeof self !== "undefined" ? self : this, () => {
return 